import React from 'react'
import {Box, IconButton, Typography} from '@mui/material'
import InfoIcon from '@mui/icons-material/Info';
import {styled} from "@mui/material/styles";

const TextBoxRoot = styled(Box)(({theme}) => ({
  borderRadius: '.5em',
  padding: '.2em',
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.palette.grey[100],
}));

const TextBoxTitle = styled(Typography)(() => ({
  fontSize: '1rem',
  fontWeight: '500',
  marginLeft: '0.5em',
}));

const TextBoxIcon = styled(IconButton)(() => ({
  color: "#007bff",
}));

const TextBox = ({title}) => {

  return (
    <TextBoxRoot>
      <TextBoxIcon>
        <InfoIcon/>
      </TextBoxIcon>
      <TextBoxTitle variant='body2'>{title}</TextBoxTitle>
    </TextBoxRoot>
  )
}

export default TextBox;
